<template>
  <div class="typing-indicator-wrapper" ref="typingIndicator">
    <div class="avatar-wrapper">
      <template v-if="participant.resource === 'ovation-bot'">
        <img
          class="avatar"
          :src="partnerStore.agentInfo.avatarUrl"
          v-if="partnerStore.agentInfo.avatarUrl"
          @error="onAvatarError"
        />
        <div
          class="avatar avatar-initials"
          :style="{ background: themeStore.theme.primaryColor }"
          v-else
        >{{ botAvatarInitial }}</div>
      </template>
      <img
        class="avatar"
        :src="participant.avatar"
        v-else-if="participant.avatar"
      />
    </div>
    <div class="from-name" v-if="participant.resource != 'ovation-bot'">
      {{ participant.name }}
    </div>
    <div class="typing-indicator" v-if="!thinking">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="thinking-indicator" v-if="thinking">
      Thinking...
    </div>
  </div>
</template>

<script>
export default {
  name: 'TypingIndiciator',
  inject: ['partnerStore', 'themeStore'],
  props: {
    participant: {
      type: Object,
      required: true,
    },
    thinking: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    botAvatarInitial() {
      const name = this.partnerStore.agentInfo.name
      return name ? name.trim().charAt(0).toUpperCase() : '?'
    },
  },
  methods: {
    onAvatarError(e) {
      e.target.style.display = 'none'
    },
  },
  mounted() {
    window.setTimeout(() => {
      this.$refs.typingIndicator && this.$refs.typingIndicator.scrollIntoView()
    }, 500)
  },
}
</script>

<style scoped lang="scss">
.typing-indicator-wrapper {
  margin-bottom: 6px;
  height: 40px;
  position: relative;
  padding-left: 36px;
}

.avatar-wrapper {
  overflow: hidden;
  position: absolute;
  top: 24px;
  left: 0px;
  width: 32px;
  height: 32px;
}

.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #fff;
  background: #fff;
}

.avatar-initials {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  user-select: none;
}

.typing-indicator {
  display: table;
  float: left;
  width: auto;
  padding: 10px;
  margin-left: 19px;
  margin-top: 8px;
  background-color: #e6e7ed;
  will-change: transform;
  border-radius: 50px;
  position: relative;
  animation: 2s bulge infinite ease-out;
  &::before,
  &::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: -11px;
    height: 12px;
    width: 12px;
    border-radius: 50%;
    background-color: #e6e7ed;
  }
  &::after {
    height: 6px;
    width: 6px;
    left: -18px;
    bottom: -3px;
  }
  span {
    height: 6px;
    width: 6px;
    float: left;
    margin: 0 1px;
    background-color: #9e9ea1;
    display: block;
    border-radius: 50%;
    opacity: 0.4;
    @for $i from 1 through 3 {
      &:nth-of-type(#{$i}) {
        animation: 1s blink infinite ($i * 0.3333s);
      }
    }
  }
}
@keyframes blink {
  50% {
    opacity: 1;
  }
}

@keyframes bulge {
  50% {
    transform: scale(1.05);
  }
}

.from-name {
  font-size: 11px;
  font-weight: bold;
  color: #97afc1;
}

.thinking-indicator {
  display: table;
  float: left;
  width: auto;
  padding: 10px 15px;
  margin-left: 19px;
  margin-top: 8px;
  background-color: #e6e7ed;
  will-change: transform;
  border-radius: 18px;
  position: relative;
  font-size: 14px;
  color: #4f4f4f;
  font-style: italic;
  animation: 2s bulge infinite ease-out;
  &::before,
  &::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: -11px;
    height: 12px;
    width: 12px;
    border-radius: 50%;
    background-color: #e6e7ed;
  }
  &::after {
    height: 6px;
    width: 6px;
    left: -18px;
    bottom: -3px;
  }
}
</style>
